// Google Play refusing to sell to an account is shown as a cancellation: nothing on our side can fix it.
export const isPlayRefusal = (reason) => /^PRODUCT_NOT_IN_PLAY/.test(reason || "");

export const displayPaymentReason = (reason) => (isPlayRefusal(reason) ? "Payment Cancelled" : reason);
